export default __webpack_public_path__ + "static/media/image-placeholder.264a9e63.png";